import { Button, Dropdown } from "antd";
import styled from "styled-components";
import { GlobalOutlined } from "@ant-design/icons";

import { langs } from "../helpers/constants";

import { useSetLanguage } from "../hooks/system";

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export default function LanguageSwitcher() {
    const { lang, setLanguage } = useSetLanguage();

    return (
        <Wrapper>
            {lang && (
                <Dropdown
                    placement="bottomLeft"
                    menu={{
                        items: Object.entries(langs).map(([code, text]) => ({
                            label: text.long,
                            key: code,
                            type: "item",
                            onClick: () => {
                                setLanguage(code);
                            },
                        })),
                    }}
                    trigger={["click"]}>
                    <Button type="default">
                        <GlobalOutlined />
                        <span
                            style={{
                                fontFamily: "monospace",
                                fontSize: 14,
                            }}>
                            {langs[lang].short}
                        </span>
                    </Button>
                </Dropdown>
            )}
        </Wrapper>
    );
}
